<div class="container">
	<div class="tips">
		<div class="tips__content">
			<div class="tips__text">
				<h1>Careers hints and tips</h1>
				<p>
					Don't let interview jitters get in the way of your dream job! Watch
					this video and unlock the secrets to acing your next interview with
					confidence and charm. Think you're ready for your interview?
				</p>
			</div>

			<div class="tips__holder" nz-row [nzGutter]="[16, 16]">
				<div nz-col nzXs="24" nzMd="24" nzLg="8">
					<a
						class="tips__item"
						href="https://www.youtube.com/watch?v=6hsmlh3fHZo&list=PLKWs3mSZ7HPkNGoH1RUsT80CRByC6MmF-&index=1"
						target="_blank"
						rel="noopener"
					>
						<div class="image-holder tip1"></div>
						<label>Recruit #1</label>
						<h1>Read before you apply.</h1>
					</a>
				</div>
				<div nz-col nzXs="24" nzMd="24" nzLg="8">
					<a
						class="tips__item"
						href="https://www.youtube.com/watch?v=1OR-SdIII5s&list=PLKWs3mSZ7HPkNGoH1RUsT80CRByC6MmF-&index=2"
						target="_blank"
						rel="noopener"
					>
						<div class="image-holder tip2"></div>
						<label>Recruit #2</label>
						<h1>Proofread your resume.</h1>
					</a>
				</div>
				<div nz-col nzXs="24" nzMd="24" nzLg="8">
					<a
						class="tips__item"
						href="https://www.youtube.com/watch?v=QGxuNDto758&list=PLKWs3mSZ7HPkNGoH1RUsT80CRByC6MmF-&index=3"
						target="_blank"
						rel="noopener"
					>
						<div class="image-holder tip3"></div>
						<label>Recruit #3</label>
						<h1>Keep your resume simple.</h1>
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
